import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from 'supabase/supabaseClient';

const LogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      const { error } = await supabase.auth.signOut();

      if (error) {
        console.error('Logout error:', error);
      }

      // Redirect to signin regardless of error
      navigate('/signin');
    };

    logout();
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Logging out...</h2>
      </div>
    </div>
  );
};

export default LogoutPage;
